import { Component, OnInit } from '@angular/core';
import { ProductTile } from "../models/product-tile.model";
import { ActivatedRoute, Router } from "@angular/router";
import { CollectionService } from "../ApplicationServices/CollectionService";
import { ProductDetailsService } from '../ApplicationServices/ProductDetailsService';
import { SliderScrollService } from "../ApplicationServices/SliderScrollService";
import { UserInfoStore } from "../shared/store/userInfo.store";

@Component({
  selector: 'app-shop-grid-dealoftheday',
  templateUrl: './shop-grid-dealoftheday.component.html',
  styleUrls: ['./shop-grid-dealoftheday.component.scss']
})
export class ShopGridDealofthedayComponent implements OnInit {

  productTileList: ProductTile[] = [];
  productList: ProductTile[] = [];
  collectionServ: CollectionService = null;
  productListAvailable = false;
  private sub: any;
  currentQuickView:ProductTile;
  showQuickView:boolean=false;
  detailedService: ProductDetailsService;
  total:0;
  range='0'

  constructor(

    private route: ActivatedRoute,
    private router: Router,
    private collectionService: CollectionService,
    private detailService: ProductDetailsService,
    private sliderService: SliderScrollService
    , private infoStore: UserInfoStore

  ) {

    this.collectionServ = collectionService;
    this.detailedService = detailService;

   }

  ngOnInit(): void {


    this.sliderService
            .getAllDealOFTheDayData()
            .subscribe((data: any) => this.manageRes(data));


            if( sessionStorage.getItem("ProceedPay_Id")=="1" ){

              this.infoStore.setCartInfo([]);
              sessionStorage.clear();
              this.infoStore.setInfo({});

             alert("Session Expired , Please Login  !!");
               //this.router.navigateByUrl("login");

             }

  }

  manageRes(data: any) {

    //this.productListAvailable = false;

    this.productList = [];
    this.total=data.length
    this.range=`1 - ${data.length}`
    for (let index = 0; index < data.length; index++) {
      let prod = new ProductTile();
      prod=data[index];
      prod.CurrentPrize ="Rs."+" "+ data[index].StrikePrice; //"$35.00";
      prod.HotLabel = data[index].PrimaryTagName;
      prod.OldPrize = "Rs."+" "+ data[index].MaxRetailPrice; //"$55.00";
      prod.ProductTileImgURL1 = data[index].img1; //"../../../assets/styles/images/books/1.jpg";
      prod.ProductTileImgURL2 = data[index].img2; //"../../../assets/styles/images/books/1.jpg";
      prod.ProductBlockImgURL = data[index].img3; //"../../../assets/styles/images/product/2.jpg";
      prod.ProductName = data[index].ItemName; //"robin parrish";
      prod.ProductURL = "#/single-product";
      prod.ItemId = data[index].ItemId;
      prod.SKUCode= data[index].SKUCode;
      prod.ProductDescription =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam fringilla augue nec est tristique auctor. Donec non est at libero vulputate rutrum. Morbi ornare lectus quis justo gravida semper. Nulla tellus mi, vulputate adipiscing cursus eu, suscipit id nulla.";

      prod.CollectionName = "DEAL";
      this.productList.push(prod);
    }
    this.productListAvailable = true;
  }
  ngOnDestroy() {
    if(this.sub){
      this.sub.unsubscribe();}
  }




  quickView(collectionName) {
    this.showQuickView = false;
    const skus = collectionName.split("&")[0];
    const collection = collectionName.split("&")[1];
    this.currentQuickView = null;
    switch (collection) {
      case "DEAL":
        this.productList.forEach((item) => {
            if (item.SKUCode == skus) {
              this.currentQuickView = item;
              this.showQuickView = true;
            }
        });
        break;

      default:
        break;

    }

  }




}
